// extracted by mini-css-extract-plugin
export default {"roundedBtn":"_2eExfZRbIhl9gyhSfVt2zW","btn-md":"_2JnPPlwnC4ts_4HmtI6XVI","btnMain":"_1AsNGlzYKSvV4wmD7TrRZI","btnSub1":"_1eELug5o_viEQxBDPk-slx","btnSub2":"_2mgbcoPV93JPuvxn34Z9HA"};